import EstateAgentReview from './EstateAgentReview.vue';

const estateAgentReviewRoutes = [
  {
    path: '/agent-review/:token',
    name: 'EstateAgentReview',
    component: EstateAgentReview,
    props: (route: any) => {
      return {
        token: route.params.token,
      };
    },
  },
];

export default estateAgentReviewRoutes;
